module.exports = __webpack_public_path__ + "static/media/team-lisa.773acd19.jpg";